// CenteredModal.js (MUI v4)
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Chip,
  Box,
  makeStyles,
  IconButton,
  Link,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: "#fff",
  },
  thumb: {
    width: 80,
    height: 80,
    objectFit: "cover",
    borderRadius: 6,
    border: "1px solid #ddd",
  },
  fileBox: {
    padding: 10,
    borderRadius: 8,
    background: "#f9f9f9",
    marginBottom: 8,
    display: "flex",
    alignItems: "center",
  },
  linkBox: {
    padding: 10,
    background: "#eef6ff",
    borderRadius: 6,
    marginBottom: 8,
    display: "flex",
    alignItems: "center",
  },
  dialogPaper: {
    borderRadius: 12,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    textAlign: "center",
    fontWeight: 600,
    paddingRight: 40, // กันไม่ให้ปุ่มทับข้อความ
  },
}));

export default function ModalReport({ open, onClose, report }) {
  const classes = useStyles();
  if (!report) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ className: classes.dialogPaper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h6" className={classes.title}>
          {report.report_name}
        </Typography>

        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>

        {/* วันที่ */}
        <Typography variant="body2" color="textSecondary">
          วันที่รายงาน: {moment(report.report_date).format("D MMM YYYY")}
        </Typography>

        <Typography variant="body2" color="textSecondary">
          อัปเดตล่าสุด: {moment(report.updated_at).format("D MMM YYYY HH:mm")}
        </Typography>

        {/* TAGS */}
        <Box mt={2} mb={2}>
          {(report.tags || []).map((t) => (
            <Chip
              key={t.id}
              label={t.name}
              className={classes.chip}
              style={{ backgroundColor: t.color }}
            />
          ))}
        </Box>

        {/* รายละเอียด */}
        <Typography variant="subtitle1">รายละเอียด:</Typography>
        <div
          style={{ marginTop: 8, lineHeight: 1.7 }}
          dangerouslySetInnerHTML={{
            __html: report.description || "<i>ไม่มีข้อมูล</i>",
          }}
        />

        {/* ===================== FILE ATTACHMENT ===================== */}
        <Box mt={3}>
          <Typography variant="h6">ไฟล์แนบ ({report.attachment?.length || 0} ไฟล์)</Typography>

          {(report.attachment || []).map((file) => (
            <div key={file.id} className={classes.fileBox}>
              {/* แสดงรูป thumbnail ถ้าเป็นรูป */}
              {file.file_type === "image" ? (
                <img src={file.full_url} className={classes.thumb} alt="" />
              ) : (
                <PictureAsPdfIcon style={{ fontSize: 40, color: "#d32f2f", marginRight: 10 }} />
              )}

              <div style={{ marginLeft: 12, flex: 1 }}>
                <Typography variant="body2">{file.file_name}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {file.file_size} KB
                </Typography>
              </div>

              <IconButton
                component="a"
                href={file.full_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <OpenInNewIcon />
              </IconButton>
            </div>
          ))}
        </Box>

        {/* ===================== URL LINKS ===================== */}
        <Box mt={3}>
          <Typography variant="h6">ลิงก์ที่เกี่ยวข้อง ({report.url?.length || 0})</Typography>

          {(report.url || []).map((u) => (
            <div key={u.id} className={classes.linkBox}>
              <OpenInNewIcon color="primary" style={{ marginRight: 10 }} />

              <Link href={u.url} target="_blank" rel="noopener noreferrer">
                {u.title || u.url}
              </Link>
            </div>
          ))}
        </Box>

      </DialogContent>
    </Dialog>
  );
}
